export const NETWORK_RPC_URLS: { [key: number]: string } = {
  250: 'https://fantom.drpc.org',
  8453: 'https://base-rpc.publicnode.com',
  146: 'https://rpc.soniclabs.com'
};
